import {combineReducers} from 'redux';
import {utilReducer} from '../utils/commonredux/commonRedux.reducer';
import {probesReducer} from '../screens/home/redux/home.reducer';
import {eventReducer} from '../screens/event/redux/events.reducer';
import {LoaderReducer} from '../commonComponents/Loader/loader.reducer';
import {walletReducer} from '../screens/wallet/redux/wallet.reducer';
import {loginReducer} from '../screens/Login/redux/login.reducer';
import {profileReducer} from '../screens/Profile/redux/profile.reducer';
import {portfolioReducer} from '../screens/portfolio/redux/portfolio.reducer';
import {socialClubReducer} from '../screens/clubs/redux/club.reducer';
import {contestLeaderboardReducer} from '../screens/contest/redux/contest.reducer';
import {rewardsReducer} from '../screens/rewards/redux/rewards.reducer';

import {liveReducer} from '../utils/live/reducer';

const appReducer = combineReducers({
  utilReducer,
  probesReducer,
  eventReducer,
  LoaderReducer,
  wallet: walletReducer,
  login: loginReducer,
  profile: profileReducer,
  portfolioReducer,
  liveReducer,
  socialClubReducer,
  contestLeaderboardReducer,
  rewardsReducer,
});

const rootReducer = (state, action) => {
  // we can do clean up here for the cases when closing the app or changing the user so as to
  // avoid the problem of cached data being leaked to the other users or
  // previous session pop ups being visible in current sessions
  return appReducer(state, action);
};

export default rootReducer;
